var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("section", [
      _c("div", { staticClass: "row", staticStyle: { padding: "0px 10px" } }, [
        _c("h2", [
          _vm._v("\n                Title and Abstract\n            "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12 form-group" }, [
          _c("label", { staticClass: "asterik", attrs: { for: "fname" } }, [
            _vm._v("\n                    Title\n                "),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.article.title,
                expression: "article.title",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", required: "required" },
            domProps: { value: _vm.article.title },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.article, "title", $event.target.value)
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "label",
      {
        class: {
          asterik: !_vm.article.section.abstracts_disabled,
        },
      },
      [_vm._v("\n        Abstract\n    ")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "author-metadata mt-0" }, [
      _c(
        "div",
        { ref: "abstract", staticClass: "row content-padding abstract" },
        [
          _vm._v(
            "\n            " +
              _vm._s("structure: " + _vm.article.abstracttype) +
              "\n            "
          ),
          _c(
            "form",
            { staticClass: "col-md-12" },
            [
              _vm.article.section && _vm.article.section.abstracts_disabled == 0
                ? [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.article.abstracttype,
                            expression: "article.abstracttype",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "structuredAbstract",
                          name: "abstractType",
                          value: "structured",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.article.abstracttype,
                            "structured"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.article,
                              "abstracttype",
                              "structured"
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          "\n                            Structured (Preferred)\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "radio" }),
                      _vm._v(" "),
                      _vm._m(0),
                    ]),
                    _vm._v(" "),
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.article.abstracttype,
                            expression: "article.abstracttype",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "unstructuredAbstract",
                          name: "abstractType",
                          value: "unstructured",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.article.abstracttype,
                            "unstructured"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.article,
                              "abstracttype",
                              "unstructured"
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          "\n                            Unstructured\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "radio" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                            Use for proposals, comments, tutorials, reviews, etc.\n                            "
                        ),
                        _c("b", [
                          _vm._v(
                            "\n                                Maximum " +
                              _vm._s(_vm.unstructuredWordCount) +
                              " words\n                            "
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.article.abstracttype == "structured"
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            _vm._l(_vm.article.abstracts, function (abstract) {
                              return _c("div", [
                                _c("label", { staticClass: "asterik" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm._f("ucfirst")(abstract.section)
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: abstract.text,
                                      expression: "abstract.text",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  staticStyle: { height: "150px" },
                                  attrs: { id: abstract.section },
                                  domProps: { value: abstract.text },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        abstract,
                                        "text",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.getWordCount()) +
                                        " / " +
                                        _vm._s(_vm.structuredWordCount) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ])
                            }),
                            0
                          ),
                        ])
                      : _vm.article.abstracttype == "unstructured"
                      ? _c("div", [
                          _c("div", { staticClass: "form-group" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.article.abstract,
                                  expression: "article.abstract",
                                },
                              ],
                              staticClass: "form-control",
                              staticStyle: { height: "500px" },
                              attrs: {
                                id: "unstructured abstract",
                                required: "required",
                              },
                              domProps: { value: _vm.article.abstract },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.article,
                                    "abstract",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                : [
                    _c("p", [
                      _vm._v("Abstracts are not used for this section."),
                    ]),
                  ],
            ],
            2
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "keywords" } }, [
        _vm._v("\n            Keywords\n        "),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            Choose terms that best describe the submission's content\n            following the categories used by this journal, and examples\n            provided by the editor. Separate terms with a semi-colon\n            (term1; term2; term3).\n        "
        ),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: this.article.subject_class,
            expression: "this.article.subject_class",
          },
        ],
        staticClass: "form-control",
        attrs: { type: "text", id: "keywords", placeholder: "Keywords" },
        domProps: { value: this.article.subject_class },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(this.article, "subject_class", $event.target.value)
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn-custom btn-custom-green",
        staticStyle: { display: "block", margin: "1rem 0px 0px auto" },
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.saveMetadata()
          },
        },
      },
      [
        _c("i", { staticClass: "fal fa-save" }),
        _vm._v(" Save non-author metadata\n    "),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "\n                            Use for original paper, systematic review or consensus paper.\n                            "
      ),
      _c("b", [
        _vm._v(
          "\n                                Maximum 450 words\n                            "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }